import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Carousel, Spinner } from "react-bootstrap";

import PsContext from "../../../context";
import { ServiceUrl } from "../../../utils/serviceUrl";
import SliderImage from "./sliderImage";
const HomeSlider = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    loadSliders();
  }, []);

  const field = (fieldName) => props?.dataSource?.[fieldName];

  const loadSliders = () => {
    setLoader(true);
    const limit = field("maxSliders");
    axios.get(ServiceUrl.LIST_SLIDERS + "?limit=" + limit).then((res) => {
      if (res["data"].status == "1") {
        setSliders(res["data"].data);
        setLoader(false);
      }
    });
  };

  return (
    <>
      {sliders && sliders.length < 1 && (
        <div style={{ height: "calc(100vh - 250px" }}>
          <center className="mt-5">
            <Spinner animation="border" role="status"></Spinner>
          </center>
        </div>
      )}
      {sliders && sliders.length > 0 && (
        <div className="ps__home__slider">
          <Carousel>
            {sliders.map((item, i) => {
              return (
                <Carousel.Item className="">
                  <SliderImage item={item} />
                </Carousel.Item>
              );
            })}
          </Carousel>
        </div>
      )}
    </>
  );
};

export default HomeSlider;
